import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit {

  signupform = new UntypedFormGroup({
    name: new UntypedFormControl(''),
    username: new UntypedFormControl(''),
    emailid: new UntypedFormControl(''),
    password: new UntypedFormControl(''),
    companyname: new UntypedFormControl(''),
    terms: new UntypedFormControl(''),
    recaptchaReactive : new UntypedFormControl('')
  });

  constructor() { }

  ngOnInit(): void {
  }
  hash = location.href.slice(location.href.lastIndexOf('#'))
}
